/* eslint-disable react/prop-types,no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { createTemplateData, updateTemplateData } from '../../flow/action';
import { handleSaveTemplate } from '../flow/action';
import TemplateInformation from './templateInformation';

class EmailTemplatesCreation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attachments: []
    };
    this.hooksFn = {};
  }

  onFileUpload = (response, error) => {
    if (_.isEmpty(error)) {
      const files = response.map((r) => r.data.id);
      this.setState({ attachments: files });
    }
  }

  registerGetContentHook = fn => {
    this.hooksFn.getHTMLContent = fn;
  };

  isNewTemplateRouter = () => this.props.location.pathname === '/setup/email/templates-creation';

  saveTemplate = () => {
    const {
      createTemplateData,
      updateTemplateData,
      newTemplate,
      editTemplate,
      history,
      content,
    } = this.props;

    if (this.isNewTemplateRouter()) {
      createTemplateData({
        folderId: newTemplate.folderId,
        name: newTemplate.name,
        apiName: newTemplate.apiName,
        content,
        description: newTemplate.description,
        category: newTemplate.category,
        attachments: this.state.attachments,
        cb: () => history.push('/setup/email/templates')
      });
    } else {
      updateTemplateData({
        templateId: editTemplate.id,
        folderId: editTemplate.folderId ? editTemplate.folderId : editTemplate.folder_id,
        name: editTemplate.name,
        apiName: editTemplate.apiName,
        content,
        description: editTemplate.description,
        category: editTemplate.category,
        attachments: this.state.attachments,
        cb: () => history.push('/setup/email/templates')
      });
    }
  }

  save = () => {
    const {
      newTemplate,
      editTemplate,
      handleSaveTemplate
    } = this.props;
    const currentTemplate = this.isNewTemplateRouter() ? newTemplate : editTemplate;
    const fn = this.hooksFn.getHTMLContent;
    let htmlContent = '<p></p>';
    if (currentTemplate.content && currentTemplate.content !== '') {
      htmlContent = currentTemplate.content;
    }
    if (fn) {
      htmlContent = fn();
    }
    handleSaveTemplate(htmlContent, this.saveTemplate);
  }

  cancel = () => this.props.history.push('/setup/email/templates');

  render() {
    const editId = this.props.match.params.templateId
    return (
      <div id="TemplateInformation">
        <TemplateInformation
          onFileUpload={this.onFileUpload}
          isNewTemplateRouter={this.isNewTemplateRouter}
          save={this.save}
          cancel={this.cancel}
          registerGetContentHook={this.registerGetContentHook}
          editId={editId}
        />
      </div>
    );
  }
}
const mapStateToProps = ({ setup, loginUser }) => {
  const { emailTemplates } = setup;
  return {
    loginUser,
    newTemplate: emailTemplates.newTemplate,
    editTemplate: emailTemplates.editTemplate,
    content: emailTemplates.selectedEmailTemplate.content
  };
};

const mapDispatchToProps = {
  createTemplateData,
  updateTemplateData,
  handleSaveTemplate,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmailTemplatesCreation));




// WEBPACK FOOTER //
// ./src/views/email/emailTemplatesCreation/container/index.js